import PropTypes from "prop-types";
import React from "react";
import { Button } from "reactstrap";

const ClubbieButton = ({
  color = "info",
  className = "clubbie-button",
  onClick,
  disabled = false,
  children,
  isLoading = false,
  ...props
}) => {
  return (
    <Button
      color={color}
      className={className}
      onClick={onClick}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        />
      )}
      {children}
    </Button>
  );
};

ClubbieButton.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
};

export default ClubbieButton;
